import React, { Component } from "react";
import moment from 'moment'
import { connect } from "react-redux";
import { showMainErrorPop } from '../../actions/popups';

import axiosVirdioT from '../../utils/axios';
var axiosVirdio;

class PersonalInfo extends Component {
  
  constructor(props) {
	super(props);
	
	this.state={
		firstName: '',
		lastName: '',
		email: '',
		heightFeet: '',
		heightInches: '',
		weightPounds: '',
		gender: '',
		dateOfBirth: '',
		editFirstName: '',
		editLastName: '',
		editEmail: '',
		editHeightFeet: '',
		editHeightInches: '',
		editWeightPounds: '',
		editGender: '',
		editDay: 0,
		editMonth: 0,
		editYear: 0,
		editPassword: '',
		isOpenEdit: false,
		genderList: ['Male', 'Female', 'Non-Binary', 'Prefer not to disclose'],
		showPassword: false,
    }
	
}
 
componentDidMount(){
	axiosVirdio = new axiosVirdioT(this.props);
	this.getUserInfo();
}

getUserInfo=()=>{
	let token = JSON.parse(localStorage.getItem('userData')).token;
    axiosVirdio.auth(token);
	axiosVirdio.post(process.env.REACT_APP_API_URL+"/api/v1/user/getUserInfo").then(res => {
		var dataResponse = res.data.responseData;
		this.setState({
			firstName: dataResponse.firstName,
			lastName: dataResponse.lastName,
			email: dataResponse.email,
			heightFeet: dataResponse.heightFeet,
			heightInches: dataResponse.heightInches,
			weightPounds: dataResponse.weightPounds,
			gender: dataResponse.gender,
			dateOfBirth: dataResponse.birthday,
			isOpenEdit: false
		});
		
		this.props.updateStateFromChild({showLoader: false});
	}).catch(err =>{ });
}

closeEditInfo=()=>{
	this.setState({
		isOpenEdit: false,
	});
}

openEdit=()=>{
	var editMonth = 0;
	var editDay = 0;
	var editYear = 0;
	if ( this.state.dateOfBirth )
		{
			var splitDate = this.state.dateOfBirth.split('-');
			editMonth = parseInt(splitDate[0]);
			editDay = parseInt(splitDate[1]);
			editYear = parseInt(splitDate[2]);
		}
		
	this.setState({
		editFirstName: this.state.firstName,
		editLastName: this.state.lastName,
		editEmail: this.state.email,
		editHeightFeet: this.state.heightFeet ? this.state.heightFeet : '',
		editHeightInches: this.state.heightInches ? this.state.heightInches : '',
		editWeightPounds: this.state.weightPounds ? this.state.weightPounds : '',
		editGender: this.state.gender ? this.state.gender : 'Prefer not to disclose',
		editDay: editDay,
		editMonth: editMonth,
		editYear: editYear,
		editPassword: '',
		isOpenEdit: true
	});
}

validateEmail=(mail)=>{
	var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
	if ( mail.match(validRegex) ) 
		{
			return true;
		}
		
	return false;
}

saveEdit=()=>{
	if ( this.state.editFirstName.trim() == '' || this.state.editFirstName.length < 2 )
		{
			this.props.showMainErrorPop("Please enter valid first name");
			return false;
		}
		
	if ( this.state.editLastName.trim() == '' || this.state.editLastName.length < 2 )
		{
			this.props.showMainErrorPop("Please enter valid last name");
			return false;
		}
		
	if ( this.state.editHeightFeet == '' || parseInt(this.state.editHeightFeet) < 0 || isNaN(parseInt(this.state.editHeightFeet)) )
		{
			this.props.showMainErrorPop("Please enter valid height feet");
			return false;
		}
		
	var feetCentimeters = parseInt(this.state.editHeightFeet) * 30.48;
	var inchCentimeters = parseInt(this.state.editHeightInches) * 2.54;
	var finalHeightCentimeters = feetCentimeters + inchCentimeters;
	
	if ( finalHeightCentimeters > 250 )
		{
			this.props.showMainErrorPop("Please enter valid height");
			return false;
		}

	if ( this.state.editHeightInches == '' || parseInt(this.state.editHeightInches) < 0 || isNaN(parseInt(this.state.editHeightInches)) )
		{
			this.props.showMainErrorPop("Please enter valid height inches");
			return false;
		}
		
	if ( this.state.editWeightPounds == '' || parseInt(this.state.editWeightPounds) < 0 || isNaN(parseInt(this.state.editWeightPounds)) )
		{
			this.props.showMainErrorPop("Please enter valid weight pounds");
			return false;
		}
		
	var weightKg = parseInt(this.state.editWeightPounds) * 0.45359237;
	
	if ( weightKg > 200 )
		{
			this.props.showMainErrorPop("Please enter valid weight");
			return false;
		}

	var dob = this.state.editMonth + '-' + this.state.editDay + '-' + this.state.editYear;
	
	if ( new Date(dob) == 'Invalid Date' )
		{
			this.props.showMainErrorPop("Please enter valid date of birth");
			return false;
		}
		
	if ( new Date(dob).getTime() > new Date().getTime() ) 
		{
			this.props.showMainErrorPop("You can't select date in future for birthday. Please enter valid date of birth");
			return false;
		}
		
	var isChangingEmail = false;
	
	if ( this.state.email !== this.state.editEmail ) 
		{
			isChangingEmail = true;
			if ( this.state.editPassword == '' )
				{
					this.props.showMainErrorPop("You are trying to change your email. In that case your password is required, please add it bellow email field");
					return false;
				}
				
			
			if ( !this.validateEmail(this.state.editEmail) )
				{
					this.props.showMainErrorPop("You are trying to change your email and new email is not valid");
					return false;
				}
		}
		
	var postData = {
		firstName: this.state.editFirstName,
		lastName: this.state.editLastName,
		heightFeet: this.state.editHeightFeet,
		heightInches: this.state.editHeightInches,
		weightPounds: this.state.editWeightPounds,
		birthday: dob,
		gender: this.state.editGender,
		ages: new Date().getFullYear() - parseInt(this.state.editYear),
		isChangingEmail: isChangingEmail,
		password: this.state.editPassword,
		email: this.state.editEmail
	};

	this.props.updateStateFromChild({showLoader: true});
	let token = JSON.parse(localStorage.getItem('userData')).token;
    axiosVirdio.auth(token);
	axiosVirdio.post(process.env.REACT_APP_API_URL+"/api/v1/user/saveUserInfo", postData).then(res => {
		this.getUserInfo();
		
		if ( isChangingEmail )
			{
				this.props.showMainErrorPop("Check your email "+this.state.email+" to confirm your new email address. We WILL NOT change your email until you confirm new email.");
			}
		else 
			{
				this.props.showMainErrorPop("You successfully saved your Personal Info");
			}			
	}).catch(err =>{
		this.props.showMainErrorPop(err.response.data.errorData);
		this.props.updateStateFromChild({showLoader: false});
	});
	
}

  render() {
	 return (
		<div className="relative_settings_content">
			{ !this.state.isOpenEdit &&
				<div>
					<div className="settings_button" onClick={this.openEdit}>EDIT</div>
					<div className="saved_info saved25">
						<div className="saved_info_title">First Name</div>
						<div className="saved_info_content">{this.state.firstName}</div>
					</div>
					<div className="saved_info saved25">
						<div className="saved_info_title">Last Name</div>
						<div className="saved_info_content">{this.state.lastName}</div>
					</div>
					<div className="saved_info saved25">
						<div className="saved_info_title">Height</div>
						<div className="saved_info_content">{this.state.heightFeet ? this.state.heightFeet : '-'} ft {this.state.heightInches ? this.state.heightInches : '-'} in</div>
					</div>
					<div className="saved_info saved25">
						<div className="saved_info_title">Weight</div>
						<div className="saved_info_content">{this.state.weightPounds ? this.state.weightPounds : '-'} lbs</div>
					</div>
					<div className="saved_info saved50">
						<div className="saved_info_title">Email</div>
						<div className="saved_info_content">{this.state.email}</div>
					</div>
					<div className="saved_info saved50">
						<div className="saved_info_title">Gender</div>
						<div className="saved_info_content">{this.state.gender ? this.state.gender : '-'}</div>
					</div>
					<div className="saved_info saved100">
						<div className="saved_info_title">Date of Birth</div>
						<div className="saved_info_content">{this.state.dateOfBirth ? moment(this.state.dateOfBirth).format('MM / DD / YYYY') : '-'}</div>
					</div>
				</div>
			}
			{ this.state.isOpenEdit &&
				<div>
					<div className="settings_button" onClick={this.saveEdit}>SAVE</div>
					<div className="saved_info saved25">
						<div className="saved_info_title">First Name</div>
						<div className="relative_holder">
							<input type="text" className="fitness_input full_input" maxLength="30" id="editFirstName" value={this.state.editFirstName} onChange={(e) => this.setState({[e.target.id]: e.target.value})} />
							{ this.state.editFirstName !== '' && <div className="empty_input" onClick={()=>this.setState({editFirstName: ""})}></div> } 
						</div>
					</div>
					<div className="saved_info saved25">
						<div className="saved_info_title">Last Name</div>
						<div className="relative_holder">
							<input type="text" className="fitness_input full_input" maxLength="30" id="editLastName" value={this.state.editLastName} onChange={(e) => this.setState({[e.target.id]: e.target.value})} />
							{ this.state.editLastName !== '' && <div className="empty_input" onClick={()=>this.setState({editLastName: ""})}></div> } 
						</div>
					</div>
					<div className="saved_info saved25">
						<div className="saved_info_title">Height</div>
						<input type="tel" className="fitness_input smaller_media_input" id="editHeightFeet" maxLength="1" value={this.state.editHeightFeet} onChange={(e) => this.setState({[e.target.id]: e.target.value})} />
						<div className="number_input_title">ft</div>
						<input type="tel" className="fitness_input smaller_media_input" id="editHeightInches" maxLength="2" value={this.state.editHeightInches} onChange={(e) => this.setState({[e.target.id]: e.target.value})} />
						<div className="number_input_title">in</div>
					</div>
					<div className="saved_info saved25">
						<div className="saved_info_title">Weight</div>
						<input type="tel" className="fitness_input weight_input smaller_media_input" id="editWeightPounds" maxLength="3" value={this.state.editWeightPounds} onChange={(e) => this.setState({[e.target.id]: e.target.value})} />
						<div className="number_input_title">lbs</div>
					</div>
					<div className="saved_info saved50">
						<div className="saved_info_title">Email</div>
						<div className="relative_holder">
							<input type="text" className="fitness_input full_input" id="editEmail" value={this.state.editEmail} onChange={(e) => this.setState({[e.target.id]: e.target.value})} />
							{ this.state.editEmail !== '' && <div className="empty_input" onClick={()=>this.setState({editEmail: ""})}></div> }
						</div>
					</div>
					<div className="saved_info saved25">
						<div className="saved_info_title">Gender</div>
						<select className="fitness_input full_input select_back" id="editGender" value={this.state.editGender} onChange={(e) => this.setState({[e.target.id]: e.target.value})}>
							{ this.state.genderList.map((def, i)=> 
								<option value={def} key={i}>{def}</option>
							)}
						</select>
					</div>
					<div className="saved_info saved50">
						<div className="saved_info_title">Password (if changing email)</div>
						<div className="relative_holder">
							<input type={this.state.showPassword ? "text" : "password"} className="fitness_input full_input" id="editPassword" value={this.state.editPassword} onChange={(e) => this.setState({[e.target.id]: e.target.value})} />
							<div className="eye_show" id="showPassword" onClick={(e)=>this.setState({[e.target.id]: !this.state.showPassword})}>
								{ this.state.showPassword && <div className="crossed_eye"></div> }
							</div>
						</div>
					</div>
					<div className="saved_info saved50">
						<div className="saved_info_title">Date of Birth</div>
						<div className="number_input_title">MM</div>
						<input type="number" className="fitness_input dates_width smaller_media_input" id="editMonth" maxLength="2" value={this.state.editMonth} onChange={(e) => this.setState({[e.target.id]: e.target.value})} />
						<div className="number_input_title">DD</div>
						<input type="number" className="fitness_input dates_width smaller_media_input" id="editDay" maxLength="2" value={this.state.editDay} onChange={(e) => this.setState({[e.target.id]: e.target.value})} />
						<div className="number_input_title">YYYY</div>
						<input type="number" className="fitness_input year_width smaller_media_input" id="editYear" maxLength="4" value={this.state.editYear} onChange={(e) => this.setState({[e.target.id]: e.target.value})} />
					</div>
				</div>
			}
		</div>
    );
  }
}

export default connect(
  null,
  { 
	showMainErrorPop
  },
  null,
  {forwardRef: true}
)(PersonalInfo);

